const DownloadAdobeReader = ({setActiveTab}:any) => {
  return (
    <div className="download-container">
          {/* Main Content */}
      <p className="warning">
        You will need Version 9 of Adobe Reader to download your book.
      </p>

      <div className="author-help_adobe">
        <p className="author-help_heading"><b>General Author Help</b></p>
        <p>Visit <a href="http://www.elsevier.com/authors/book-authors" target="_blank" rel="noopener noreferrer">http://www.elsevier.com/authors/book-authors</a></p>
      </div>

  <div className="information_text">
      <p>
        <b>If you already have the correct version of Adobe Reader, then you can download your copy by clicking on the next button below.</b>
      </p>
      <p>
        You can return to any page using the back and next buttons below, or by  using the menu at the top of this page.
        </p>
      </div>
     
      {/* Download Link */}
      <div className="adobe_download_link">
      <p>
        Download the latest version using the link below:
        <br />
        <a href="http://get.adobe.com/uk/reader/" target="_blank" rel="noopener noreferrer">
          http://get.adobe.com/uk/reader/
        </a>
      </p>
      </div>
      <div className="adobe-buttons">
      <button className="back-button" onClick={() => setActiveTab('home')}>BACK</button>
      <button className="next-button" onClick={() => setActiveTab('book')}>NEXT</button>
      </div>

    </div>
  );
};

export default DownloadAdobeReader;
